import { ShipmentLeadTime } from 'app/modules/settings/domain/entity/ShipmentLeadTime';
import { Id } from 'app/shared/domain/value-objects/id';
import { DayOfWeek } from 'app/modules/settings/domain/valueObject/DayOfWeek';
import { LeadDays } from 'app/modules/settings/domain/valueObject/LeadDays';
import { ShipmentLeadTimeResponse } from 'app/modules/settings/infrastructure/dto/response/ShipmentLeadTimeResponse';
import { DayOfWeekMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/DayOfWeekMapper';

export class ShipmentLeadTimeMapper {

    static toDomain(dto: ShipmentLeadTimeResponse): ShipmentLeadTime {
        return new ShipmentLeadTime(
            new Id(dto.id),
            new DayOfWeek(DayOfWeekMapper.toDomain(dto.day_of_week)),
            new LeadDays(dto.lead_days),
        );
    }

}
